export const Navigation = (props) => {
  return (
    <nav id='menu' className='navbar navbar-default navbar-fixed-top'>
      <div className='container'>
        <div className='navbar-header'>
          <button
            type='button'
            className='navbar-toggle collapsed'
            data-toggle='collapse'
            data-target='#bs-example-navbar-collapse-1'
          >
            {' '}
            <span className='sr-only'>Toggle navigation</span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
          </button>
          <a className='navbar-brand page-scroll' href='#page-top'>
            <img className="logo" src="img/BEYSOFT_LOGO-02.jpg" alt="profile"></img>
          </a>{' '}
        </div>

        <div
          className='collapse navbar-collapse'
          id='bs-example-navbar-collapse-1'
        >
          <ul className='nav navbar-nav navbar-right'>
            <li>
              <a href='#features' className='page-scroll'>
                About
              </a>
            </li>
            <li>
              <a href='#business' className='page-scroll'>
                Business
              </a>
            </li>
            <li>
              <a href='#platform' className='page-scroll'>
                Platform
              </a>
            </li>
            <li>
              <a href='#solution' className='page-scroll'>
                Solution
              </a>
            </li>
            <li>
              <a href='#service' className='page-scroll'>
                Services
              </a>
            </li>
            <li>
              <a href='#clients' className='page-scroll'>
                Clients
              </a>
            </li>
            <li>
              <a href='#recruit' className='page-scroll'>
                RECRUIT
              </a>
            </li>
            <li>
              <a href='http://biz.beys.io' target='BIZ_INTERPRETER'>
                BZ Trend
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  )
}